import Api from "~/service/Api";

class UserRepository {
  login(data) {
    return Api.post("/authentication", data);
  }

  logout() {
    return Api.delete("/authentication");
  }
}

export default UserRepository;
